import PrivacyPolicyComponent from 'components/marketingSite/privacyPolicy/PrivacyPolicyComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';

type PrivacyPolicyPageProps = WithBaseUrl;

const PrivacyPolicyPage: React.FC<PrivacyPolicyPageProps> = () => {
  const { t } = useI18n('privacyPolicy');

  usePageTrack('Website - Page Loaded');

  return (
    <>
      <HeadMetadata
        url={APP_URLS.privacyPolicy}
        title={t('title')}
        desc={t('description')}
      />
      <PrivacyPolicyComponent />
    </>
  );
};

export default PrivacyPolicyPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'privacyPolicy'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
